'use client';
import { PropsWithChildren } from 'react';

import { PageData, PageNavigationData } from '@/types/ssr';

import { MathJaxProvider } from './MaxjaxContext';
import { PageDataProvider } from './PageData';
import { PageNavigationProvider } from './PageNavigation';
export function DynamicPageProviders({
  children,
  pageData,
  pageNavigationData,
  authRequired,
}: PropsWithChildren<{ pageData: PageData; pageNavigationData: PageNavigationData; authRequired: boolean }>) {
  return (
    <MathJaxProvider>
      <PageDataProvider authRequired={authRequired} pageData={pageData}>
        <PageNavigationProvider pageNavigationData={pageNavigationData}>{children}</PageNavigationProvider>
      </PageDataProvider>
    </MathJaxProvider>
  );
}
